/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useRef, useState } from "react";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ThemeMaker from "../../components/thememaker";
import axios from "axios";
import { tokenDecode } from "../../utils/helper";
import { config } from "../../utils/config";
import styled from "styled-components"
import BeatLoader from "react-spinners/BeatLoader";
import "./switch.css";
import { show, hide } from "react-functional-modal"
import Invoice from "../Invoice/Invoice";
import html2pdf from 'html2pdf.js';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import CloseIcon from '@mui/icons-material/Close';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
// import * as  ReactModal from "@types/react-modal"
// import "./styles.css";

const { apiEndpoint, baseNodeapiUrl, awsKeyId, awsSecretKey, awsRegion, awsBucket } = config;
const aws = require("aws-sdk");
const Pbutton = styled.button`
  outline: none;
  border: none;
  margin-left: 18px;
  background: #f97316;
  padding: 6px 16px;
  border-radius: 10px;
  font-weight: 600;
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(249, 115, 22, 0.25);
  transition: all 0.2s ease;
  &:hover {
    background: #ea580c;
  }
`;
const ProviderContainer = styled.div`
  background: #ffffff;
  min-width: 60%;
  border: 1.5px solid #f97316;
  position: relative;
  padding: 16px;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.04);
`;
const ListContainer = styled.div`
  background: #fff7ed;
  width: 90%;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 600;
  color: #c2410c;
  border-radius: 12px;
  border: 1px solid #ffedd5;
`;

const textStyle1 = {
  fontWeight: "600",
  fontSize: "17px",
  color: "black"
};

const tableStyle = {
  width: "35%",
  maxWidth: "40%"
};

const tableLabelStyle: React.CSSProperties = {
  width: "38%",
  minWidth: "110px",
  backgroundColor: "#f8fafc",
  color: "#475569",
  fontWeight: 600,
  fontSize: "13px",
  padding: "10px 14px",
  verticalAlign: "middle",
  borderBottom: "1px solid #f1f5f9"
};

const tableValueStyle: React.CSSProperties = {
  color: "#0f172a",
  fontWeight: 600,
  fontSize: "13px",
  padding: "10px 14px",
  verticalAlign: "middle",
  wordBreak: "break-word",
  borderBottom: "1px solid #f1f5f9"
};

const orderDetail = () => {
  const [showPop, setShowPop] = useState(false);

  const toggle = (e: any) => {
    e.preventDefault();
    setShowPop(true);
  };

  let params = useParams();
  const { id: order_id }: any = params;
  const [alldetails, setalldetails] = useState<any>([]);
  // console.log("all details-------------", alldetails);
  const decoded = tokenDecode();
  const { data } = decoded;
  const { permission: { order }, } = data;
  const [isLoading, setIsLoading] = useState(false);
  const [agentFieldsReadOnly, setAgentFieldsReadOnly] = useState(false);
  const [updateOrder_, setUpdateOrder_] = useState({
    order_id: "",
    tracking_url: "",
    order_state: "",
  });
  const [orderDetail, setorderDetail]: any = useState([]);
  const [_orderDetail, _setorderDetail]: any = useState({
    billing_address: "",
    contact_number: "",
    created_at: "",
    email: "",
    id: "",
    name: "",
    order_id: "",
    order_state: "",
    provider_id: "",
    shipping_address: "",
    status: "",
    total_price: 0,
    return_amount: 0,
  });
  console.log("_orderDetail--->", _orderDetail)
  const [orderState, setOrderState] = useState<{
    order_id: any;
    order_state: string;
    fulfillment_state: string;
    tracking_url: string;
    agent_name?: string;
    agent_contact?: string;
  }>({
    order_id,
    order_state: "",
    fulfillment_state: "",
    tracking_url: "",
    agent_name: "",
    agent_contact: "",
  });

  const [isChecked, setisChecked]: any = useState("");
  const [cancelvalue, setCancelvalue]: any = useState("");
  const [cancelPartialreson, setCancelPartialreson]: any = useState("");
  const [logisticCharges, setlogisticCharges]: any = useState("")
  let rawdata;
  const [orderCancle, setOrderCancle]: any = useState({
    order_id,
    order_status: "Created",
    product_id: [],
  });

  const [addButton, setaddButton] = useState(true);
  const [sendingOrderStatus, setsendingOrderStatus] = useState(false);


  const [orderStatus, setorderStatus] = useState([
    "Created",
    "Accepted",
    "In-progress",
    "Completed",
    // "Cancelled",
    // "Returned",
  ]);

  const steps = [
    'Order Picked Up',
    'In-Transit',
    'Delivered',
  ];

  const getorderDetails = async (order_id: any) => {
    setIsLoading(true);
    try {
      const { data } = await axios({
        url: `${apiEndpoint}/snp/orders/getOrderdetails/${order_id}`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
        },
      });

      if (data.status === true || data.status === 200 || data.status === "200") {
        setIsLoading(false);

        // Normalize order object (support data.orders, data.data, or data.order)
        const orderObj = (data.orders && data.orders.length > 0)
          ? data.orders[0]
          : ((data.data && data.data.length > 0) ? data.data[0] : (data.order || {}));

        // Normalize products list (support data.products, data.product, or data.data)
        let productList: any[] = [];
        if (data.products && Array.isArray(data.products)) {
          productList = data.products;
        } else if (data.product) {
          productList = Array.isArray(data.product) ? data.product : [data.product];
        } else if (data.data && Array.isArray(data.data)) {
          productList = data.data;
        }

        setorderDetail(productList);

        // Invoice
        const invPath = orderObj?.invoice_url || orderObj?.invoice || "";
        setInvoiceHolder({
          path: invPath || "",
          origin: invPath ? "database" : "manual"
        });

        // Quote / Logistic charges
        let parsedQuote: any = null;
        if (orderObj?.quote) {
          try {
            parsedQuote = typeof orderObj.quote === "string" ? JSON.parse(orderObj.quote) : orderObj.quote;
          } catch (e) {
            console.error("Quote JSON parse error:", e);
          }
        }
        setlogisticCharges(parsedQuote);

        setalldetails(data);

        let totalP = 0;
        productList.forEach((item: any) => {
          totalP += parseFloat(item?.price || 0);
        });

        const currentOrderState = orderObj?.order_state || "";
        if (currentOrderState !== "") {
          const index = orderStatus.indexOf(currentOrderState);
          if (index !== -1) {
            setorderStatus(orderStatus.slice(index));
          }
        }

        const firstProd = productList[0] || {};
        const apiAgentName = firstProd?.agent_name || orderObj?.agent_name || "";
        const apiAgentContact = firstProd?.agent_contact || orderObj?.agent_contact || "";
        const apiTrackingUrl = firstProd?.tracking_url || orderObj?.tracking_url || "";
        setAgentFieldsReadOnly(Boolean(apiAgentName || apiAgentContact || apiTrackingUrl));

        setOrderState({
          ...orderState,
          order_state: currentOrderState,
          tracking_url: firstProd?.tracking_url || orderObj?.tracking_url || "",
          fulfillment_state: firstProd?.fulfillment_state || "",
          agent_name: firstProd?.agent_name || orderObj?.agent_name || "",
          agent_contact: firstProd?.agent_contact || orderObj?.agent_contact || "",
        });

        setUpdateOrder_({
          ...updateOrder_,
          order_id: orderObj?.order_id || order_id,
          tracking_url: orderObj?.tracking_url || firstProd?.tracking_url || "",
          order_state: currentOrderState,
        });

        // Safely parse billing JSON string or object
        let parsedBilling: any = orderObj?.billing || {};
        if (typeof parsedBilling === "string") {
          try {
            parsedBilling = JSON.parse(parsedBilling);
          } catch (e) {
            console.error("Billing JSON parse error:", e);
          }
        }

        // Safely parse fulfillments JSON string or object
        let parsedFulfillments: any = orderObj?.fulfillments || [];
        if (typeof parsedFulfillments === "string") {
          try {
            parsedFulfillments = JSON.parse(parsedFulfillments);
          } catch (e) {
            console.error("Fulfillments JSON parse error:", e);
          }
        }

        const orderTotalVal = orderObj?.order_total !== undefined
          ? (typeof orderObj.order_total === "string" ? parseFloat(orderObj.order_total) : (orderObj.order_total || 0))
          : 0;

        const returnAmountVal = orderObj?.return_amount ? parseFloat(orderObj.return_amount) : 0;

        _setorderDetail({
          ..._orderDetail,
          ...orderObj,
          name: orderObj?.name || parsedBilling?.name || "N/A",
          return_amt: orderTotalVal - returnAmountVal,
          total_price: orderTotalVal,
          return_amount: returnAmountVal,
          billing_address: parsedBilling,
          shipping_address: parsedFulfillments,
        });

        rawdata = productList.map((item: any) => ({
          item_id: item.product_id || item.id,
          order_status: currentOrderState,
          qty: cancelvalue,
        }));

        setOrderCancle({
          ...orderCancle,
          order_id: orderObj?.order_id || order_id,
          product_id: Object.assign({}, rawdata),
        });
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      console.log("error", error);
      setIsLoading(false);
    }
  };

  console.log("alldetails------------>", alldetails)

  const updateOrder = async (product_id: any) => {
    try {
      // console.log(orderDetail);
      const getItem = orderDetail.find(
        (item: any) => item?.product_id === product_id
      );
      // console.log("getItem", getItem);
      const { data } = await axios({
        url: `${apiEndpoint}/updateorderstatus`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: getItem,
      });
      // console.log(data, "datadata");

      if (data.message === "flag1") {
        toast.success("Item status updated !", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error("Something went wrong !", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      console.log("yess", error);

      // console.log("update error", error);
      // toast.error("404 error !", {
      //     position: "top-right",
      //     autoClose: 5000,
      //     hideProgressBar: false,
      //     closeOnClick: true,
      //     pauseOnHover: true,
      //     draggable: true,
      //     progress: undefined,
      // });

      // window.location.reload();
    }
  };
  const updateOrderChangeHandler = (e: any, index: any) => {
    // setUpdateOrder_({ ...updateOrder_, [e.target.name]: e.target.value })
    // console.log(e.target.value, "index---", e.target.name, index);
    const newUpdate: any = orderDetail;
    newUpdate[index][e.target.name] = e.target.value;
    // console.log(newUpdate, "newUpdate");

    setorderDetail([...newUpdate]);
  };
  const updateThisOrder = async (e: any) => {
    console.log("orderState---->", orderState);
    if (orderState?.fulfillment_state === "Agent-assigned") {
      if (!orderState?.agent_name || !orderState.agent_name.trim()) {
        toast.error("Agent Name is required when Agent-assigned is selected!");
        return;
      }
      if (!orderState?.agent_contact || !orderState.agent_contact.trim()) {
        toast.error("Agent Contact is required when Agent-assigned is selected!");
        return;
      }
      if (!orderState?.tracking_url || !orderState.tracking_url.trim()) {
        toast.error("Tracking URL is required when Agent-assigned is selected!");
        return;
      }
      if (!orderState.tracking_url.trim().startsWith("https://")) {
        toast.error("Tracking URL must start with https://");
        return;
      }
    } else if (orderState?.tracking_url && !orderState.tracking_url.trim().startsWith("https://")) {
      toast.error("Tracking URL must start with https://");
      return;
    }
    try {

      const { data } = await axios({
        url: `${apiEndpoint}/updateorderstatus`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: orderState,
      });
      console.log("orderState", orderState);

      if (data.status === 200) {

        const index = orderStatus.indexOf(orderState.order_state);
        if (index !== -1) {
          setorderStatus(orderStatus.slice(index));
        }


        if (orderState.order_state === "Created") {
          toast.success("Order Created successfully!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else if (orderState.order_state === "Accepted") {
          toast.success("Order Accepted successfully!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else if (orderState.order_state === "In-progress") {
          toast.success("Order In-progress!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else if (orderState.order_state === "Completed") {
          toast.success("Order Completed successfully!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else if (orderState.order_state === "Cancelled") {
          toast.success("Order Cancelled successfully!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        // toast.success("Order updated !", {
        //   position: "top-right",
        //   autoClose: 5000,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        // });
      } else {
        toast.error("Something went wrong !", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (error) {
      toast.error("Something went wrong 500 !", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const cancleQty = (item: any, setCancelvalue: any) => {
    item.qty = setCancelvalue;
    // setCancelvalue(cancelvalue);
    // console.log("value", item.qty);
  };
  const cancleReason = (item: any, setCancelPartialreson: any) => {
    item.reason = setCancelPartialreson;
    // setCancelPartialreson(cancelPartialreson);
    // console.log("reason", item.reason);
  };
  const cancleChecked = (item: any, setisChecked: any) => {
    item.Checked = setisChecked;
    // setCancelPartialreson(cancelPartialreson);
    // console.log("Checked", item.Checked);
  };

  const [cancelQuantityl, setcancelQuantityl] = useState("")
  const [reasonCode, setreasonCode] = useState("")
  const [cancellingProduct, setcancellingProduct] = useState("")
  const [showGreaterValueAlert, setshowGreaterValueAlert] = useState(false)
  const [showEnterValueAlert, setshowEnterValueAlert] = useState(false)
  const [showCancelQuantityGreaterthenOrderQuantity, setshowCancelQuantityGreaterthenOrderQuantity] = useState(false)

  const cancleUpdate = (
    cancelvalue: any,
    cancelPartialreson: any,
    item: any,
    item_id: any,
    order_status: any
  ) => {
    // e.preventDefault();
    // console.log("302 orderCancle", orderCancle);

    //line 288 issue

    // const newrawdata = orderDetail.map((item: any, i: any) => ({
    //   item_id: item_id,
    //   order_status: orderState.order_state,
    //   qty: item.qty,
    //   reason: item.reason,
    // }));
    const newrawdata = [
      {
        item_id: item_id,
        order_status: order_status,
        cancel_quantity: item.qty,
        reason_code: item.reason,
      },
    ];
    // setOrderCancle({...ordercancel,order_status:order_status})
    // console.log("line 294", newrawdata);
    orderCancle.product_id = Object.assign({}, newrawdata);
    // console.log("line 297", orderCancle);
  };
  // const cancelPartial = async (e: any) => {
  //   // console.log("line 307", orderCancle);
  //   // const id = toast.loading("Please wait...");
  //   try {
  //     // console.log("orderState---->", orderState);
  //     const response = await axios({
  //       url: `${apiEndpoint}/sellerordercancel`,
  //       method: "POST",
  //       headers: {
  //         "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
  //       },
  //       data: orderCancle,
  //     });
  //     if (response.status === 200) {
  //       toast.success("Order cancel updated !", {
  //         position: "top-right",
  //         autoClose: 5000,
  //         hideProgressBar: false,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //         progress: undefined,
  //       });
  //     } else {
  //       // console.log("response for cancelation", response);
  //       toast.error("Something went wrong !", {
  //         position: "top-right",
  //         autoClose: 5000,
  //         hideProgressBar: false,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //         progress: undefined,
  //       });
  //     }
  //   } catch (error) {
  //     console.error(" error 784", error);
  //     toast.error("Something went wrong !", {
  //       position: "top-right",
  //       autoClose: 5000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //     });
  //   }
  // };



  const cancelPartial = async (e: any, item: any) => {
    setcancellingProduct(item.id)
    let payload = {
      "order_id": orderCancle?.order_id,
      "order_status": orderState.order_state,
      "product_id": {
        "0": {
          "item_id": item.product_id,
          "order_status": orderState.order_state,
          "cancel_quantity": cancelQuantityl,
          "reason_code": reasonCode
        }
      }
    }
    // console.log(cancelQuantityl, reasonCode)
    if (cancelQuantityl <= item.quantity) {
      if (reasonCode !== "" && cancelQuantityl !== "") {
        // alert()
        try {
          const response = await axios({
            url: `${apiEndpoint}/sellerordercancel`,
            method: "POST",
            headers: {
              "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
            },
            data: payload,
          });
          if (response.status === 200) {
            setcancellingProduct("");
            getorderDetails(order_id);
            setcancelQuantityl("")
            setreasonCode("")
            toast.success("Order cancel updated !", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            // console.log("response for cancelation", response);
            setcancellingProduct("")
            toast.error("Something went wrong !", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        } catch (error) {
          console.error(" error 784", error);
          setcancellingProduct("")
          toast.error("Something went wrong !", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      } else {
        setcancellingProduct("")
        // alert("Please enter cancel quantity and reason for cancel")
        setshowEnterValueAlert(true)
        setTimeout(() => {
          setshowEnterValueAlert(false)
        }, 4000);
      }
    } else {
      setcancellingProduct("")
      setshowCancelQuantityGreaterthenOrderQuantity(true)
      setTimeout(() => {
        setshowCancelQuantityGreaterthenOrderQuantity(false)
      }, 4000);
      // alert("Cancel quantity price cannot be greater than Order Quantity")
    }
  };

  useEffect(() => {
    getorderDetails(order_id);
    // window.scrollTo(0, 0)
    // console.log(_orderDetail.order_state, "<-----------_orderDetail.order_state ")
  }, []);

  // if (_orderDetail.order_state !== "") {
  //     const index = orderStatus.indexOf(_orderDetail.order_state);
  //     if (index !== -1) {
  //       setorderStatus(orderStatus.slice(index));
  //     }
  //   }
  // console.log("orderDetails---->", _orderDetail);
  // console.log("orderStatus---->", orderStatus);
  const [cancelpopup, setcancelpopup] = useState(false);
  const [selectedStatus, setselectedStatus] = useState();
  const cancelbtn = () => {
    setcancelpopup(true);
    // console.log("cancelPopup");
  };

  const [cancelreson, setcancelreson] = useState("");

  const cancelReasonStatement = [
    {
      text: "Price of one or more items have changed due to which buyer was asked to make additional payment",
      code: "001",
      show: false,
    },
    {
      text: "One or more items in the Order not available",
      code: "002",
      show: true
    },
    {
      text: "Product available at lower than order price",
      code: "003",
      show: false,
    },
    {
      text: "Order in pending shipment / delivery state for too long",
      code: "004"
    },
    {
      text: "Merchant rejected the order",
      code: "005",
      show: true
    },
    {
      text: "Order not shipped as per buyer app SLA",
      code: "006",
      show: false,
    },
    {
      text: "Order not ready for pickup",
      code: "008",
      show: false,
    },
    {
      text: "Wrong product delivered",
      code: "009",
      show: false,
    },
    {
      text: "Buyer wants to modify details",
      code: "010",
      show: false,
    },
    {
      text: "Buyer not found or cannot be contacted",
      code: "011",
      show: true
    },
    {
      text: "Buyer does not want product any more",
      code: "012",
      show: true
    },
    {
      text: "Buyer refused to accept delivery",
      code: "013",
      show: true
    },
    {
      text: "Address not found",
      code: "014",
      show: true
    },
    {
      text: "Buyer not available at location",
      code: "015",
      show: true
    },
    {
      text: "Accident / rain / strike / vehicle issues",
      code: "016",
      show: false,
    },
    {
      text: "Order delivery delayed or not possible",
      code: "017",
      show: false,
    },
    {
      text: "Delivery pin code not serviceable",
      code: "018",
      show: true
    },
    {
      text: "Pickup pin code not serviceable",
      code: "019",
      show: true
    },
    {
      text: " Order lost in transit",
      code: "020",
      show: true
    },
  ]
  const changeReturnStatus = (selectedStatus: any) => {
    // console.log("selectedStatus", selectedStatus);
    // istatus = selectedStatus;
    setcancelreson(selectedStatus);
  };

  const ordercancel = async () => {
    // console.log("cancel", cancelreson);
    // console.log("orderCancel hit");

    const statusData = {
      order_id: order_id,
      reason_code: cancelreson,
    };

    try {
      const response = await axios({
        method: "post",
        url: `${baseNodeapiUrl}/shiprocket/unsolicated_cancel`,
        headers: { "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}` },
        data: statusData,
      })
        .then(function (response) {
          // console.log("response 173", response);
          toast.success("Order Cancelled")
          setcancelpopup(false);
        })
        .catch(function (error) {
          console.log("error 176", error);
          toast.error("Something Went Wrong!");
        })
        .finally(function () {
          // console.log("response   // always executed 179");
        });
    } catch (error) {
      console.error(" error 784", error);
    }
  };

  // ---------------------------------- Code functions for logistics Start------------------------------------------------

  const [selectProvider, setselectProvider]: any = useState(null);
  const [providerPayload, setproviderPayload]: any = useState({
    transaction_id: "",
    message_id: ""
  })
  const [providersData, setprovidersData]: any = useState([])
  const [submitData, setSubmitData]: any = useState([])
  const controller = useRef(false)
  interface Item {
    id: number;
    checked: boolean;
  }
  const [issChecked, setIssChecked] = useState<Item[]>([]);
  const [isinitRunning, setisinitRunning] = useState(false);
  const [WeightSection, setWeightSection] = useState(false);

  const [wAndD, setwAndD]: any = useState({
    weight: '',
    weightUnit: "",
    length: '',
    width: '',
    height: '',
    dimensionUnit: ""
  })



  // useEffect(() => {
  //   setTimeout(() => {
  //     getProviders()
  //   }, 3000);
  // }, [providerPayload])
  // useEffect(() => {
  //   if (controller.current !== false) {
  //     open()
  //   }


  // }, [submitData])

  function WandChangeHandler(e: any) {
    setwAndD({ ...wAndD, [e.target.name]: e.target.value })
  }

  async function getProvidersPayload() {
    console.log("form data", wAndD)
    let dataTosend = {
      order_id: order_id,
      weight: {
        unit: wAndD.weightUnit,
        value: parseInt(wAndD.weight)
      },
      dimensions: {
        length: {
          unit: wAndD.dimensionUnit,
          value: parseInt(wAndD.length)
        },
        breadth: {
          unit: wAndD.dimensionUnit,
          value: parseInt(wAndD.width)
        },
        height: {
          unit: wAndD.dimensionUnit,
          value: parseInt(wAndD.height)
        }
      }
    }
    setselectProvider(false)
    try {
      const { data } = await axios({
        url: `${baseNodeapiUrl}/adapter/logistics/search`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: dataTosend
      })
      // console.log("search--->", data)
      if (data?.data) {
        const { transaction_id, message_id } = data.data.context
        setproviderPayload((prev: any) => {
          return { ...prev, transaction_id: transaction_id, message_id: message_id }
        })


      }
    } catch (err) {
      console.log("err----->", err);
      setselectProvider(null)
      toast.error("Please Try Again! Something Went Wrong", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  // async function getProviders() {
  //   const { data } = await axios({
  //     url: `https://prod-sellerapp.shiprocket.com/adapter/logistics/providers`,
  //     method: "POST",
  //     headers: {
  //       "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
  //     },
  //     data: providerPayload
  //   })

  //   setTimeout(() => {
  //     if (data.message == "flag1" && data?.data.length > 0) {
  //       setprovidersData(data.data)
  //       setselectProvider(true)
  //     } else {
  //       setselectProvider(null)
  //     }
  //   }, 3000);
  // }

  async function selectLogisticProvider(item: any, itemId: any) {

    setSubmitData(item);
    setIssChecked((prevItems: any) =>
      prevItems.map((item: any) =>
        item.id === itemId ? { ...item, checked: true } : { ...item, checked: false }
      )
    );

  }


  const [isSelectingProviders, setisSelectingProviders] = useState(false);
  const [isConfirmingProviders, setisConfirmingProviders] = useState(false);

  async function submitSelectedProvider() {
    setisSelectingProviders(true)
    const { transaction_id, message_id, bpp_id, bpp_uri, descripter, bpp_provider_id, item, location } = submitData
    const { data } = await axios({
      url: `${baseNodeapiUrl}/adapter/logistics/init`,
      method: "POST",
      headers: {
        "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
      },
      data: {
        "order_id": order_id,
        "transaction_id": transaction_id,
        "message_id": message_id,
        "bpp_id": bpp_id,
        "bpp_uri": bpp_uri,
        "descripter": descripter,
        "bpp_provider_id": bpp_provider_id,
        "category_id": item.category_id,
        "items_id": item.id,
        "descriptor": item.descriptor.code,
        "fulfillment_id": item.fulfillment_id,
        "location": location == null ? '' : location[0].id

        // "order_id": "2023-05-30-676472",
        // "transaction_id": "b1f11486-6a48-422b-aaf3-e6d98bfbffbf",
        // "message_id": "9569f153-9933-4046-a8f9-347b7fad9e20",
        // "bpp_id": "qaapis.delcaper.com",
        // "bpp_uri": "https://qaapis.delcaper.com/public/ondc",
        // "descripter": "Delcaper",
        // "descriptor": "P2P",
        // "bpp_provider_id": "Delcaper",
        // "category_id": "Same Day Delivery",
        // "items_id": "1",
        // "fulfillment_id": 1

      }
    })

    if (data?.data?.message?.ack?.status == "ACK") {
      setTimeout(() => {
        setprovidersModalOpen(false)
        setisSelectingProviders(false)
        console.log("timer function")
        hide("key#1")
        setisConfirmingProviders(true)
      }, 2000);
    } else {
      setisSelectingProviders(false)
      alert("Init Failed")

    }


  }


  const [isConfirmingProvider, setisConfirmingProvider] = useState(false)
  const [isUpdatingProvider, setisUpdatingProvider] = useState(false)
  const onConfirmHandler = async (cdata: any) => {
    try {
      setisConfirmingProvider(true)
      const { transaction_id, message_id, bpp_id, bpp_uri, descripter, bpp_provider_id, item, bpp_descriptor_name } = submitData

      const { data } = await axios({
        url: `${baseNodeapiUrl}/adapter/logistics/confirm`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: {
          "transaction_id": transaction_id,
          "message_id": message_id,
          "bpp_id": bpp_id,
          "bpp_uri": bpp_uri,
          "order_id": order_id,
          "bpp_descriptor_name": bpp_descriptor_name
        }
      })

      if (data?.data?.message?.ack?.status == "ACK") {
        setisConfirmingProvider(false)
        toast.success("Provider Confirmed !", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        // hide("key#2")
      } else {
        setisConfirmingProvider(false)
        toast.error("Something went wrong !", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (err) {
      setisConfirmingProvider(false);
      toast.error("Something went wrong !", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log("error---->", err)
    }
  }
  const updateLSP = async (cdata: any) => {

    try {
      setisUpdatingProvider(true)
      const { transaction_id, message_id, bpp_id, bpp_uri, descripter, bpp_provider_id, item } = submitData

      const { data } = await axios({
        url: `${baseNodeapiUrl}/adapter/logistics/update`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: {

          "transaction_id": transaction_id,
          "message_id": message_id,
          "bpp_id": bpp_id,
          "bpp_uri": bpp_uri,
          "order_id": order_id

          // "order_id": "2023-05-30-676472",
          // "transaction_id": "b1f11486-6a48-422b-aaf3-e6d98bfbffbf",
          // "message_id": "9569f153-9933-4046-a8f9-347b7fad9e20",
          // "bpp_id": "qaapis.delcaper.com",
          // "bpp_uri": "https://qaapis.delcaper.com/public/ondc",
          // "descripter": "Delcaper",
          // "descriptor": "P2P",
          // "bpp_provider_id": "Delcaper",
          // "category_id": "Same Day Delivery",
          // "items_id": "1",
          // "fulfillment_id": 1

        }
      })

      if (data?.data?.message?.ack?.status == "ACK") {
        setisUpdatingProvider(false)
        toast.success("Provider Confirmed !", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        // hide("key#2")
      } else {
        setisUpdatingProvider(false)
        toast.error("Something went wrong !", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } catch (err) {
      setisUpdatingProvider(false)
      console.log("error---->", err)
    }
  }



  const [shipmentStatusLoading, setshipmentStatusLoading] = useState(false)
  const [shipmentModalOpen, setshipmentModalOpen] = useState(false);
  const [providersModalOpen, setprovidersModalOpen] = useState(false)
  const Sstyle = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',

    bgcolor: 'background.paper',
    border: '1px solid #000',
    boxShadow: 24,
    p: 2,
  };
  const PSstyle = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    p: 2,
  };

  const getShipmentStatus = async () => {
    setshipmentStatusLoading(true)
    setTimeout(() => {
      setshipmentModalOpen(true)
      setshipmentStatusLoading(false)
      // statusModal()
    }, 2000);

    try {
      const { data } = await axios({
        method: "POST",
        url: `${baseNodeapiUrl}/adapter/logistics/status`,
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: {
          "buyer_order_id": "2023-07-31-509804"
        }
      })
      // console.log("data----->", data)
    } catch (err) {
      console.log("some error--->", err)
    }


  }

  function handleShipementModalClose() {
    setshipmentModalOpen(false)
  }

  // const statusModal = () => {
  //   show(

  //     <ProviderContainer>

  //       <div className="d-flex justify-content-end">
  //         <span style={{ cursor: "pointer" }} onClick={() => {
  //           hide("key#3")
  //         }}><CloseIcon /></span>
  //       </div>
  //       <div style={{ padding: "20px" }}>

  //         <Box sx={{ width: '100%' }}>
  //           <Stepper activeStep={0} alternativeLabel>
  //             {steps.map((label) => (
  //               <Step key={label}>
  //                 <StepLabel >{label}</StepLabel>
  //               </Step>
  //             ))}
  //           </Stepper>
  //         </Box>
  //       </div>
  //     </ProviderContainer>,
  //     {
  //       key: "key#3",
  //       fading: true
  //     }
  //   )

  // }





  // ---------------------------------- Code functions for logistics End------------------------------------------------



  const [isUpdatingOrder, setIsUpdatingOrder] = useState(false);

  const handleUpdateOrder = async () => {
    if (orderState?.fulfillment_state === "Agent-assigned") {
      if (!orderState?.agent_name || !orderState.agent_name.trim()) {
        toast.error("Agent Name is required when Agent-assigned is selected!");
        return;
      }
      if (!orderState?.agent_contact || !orderState.agent_contact.trim()) {
        toast.error("Agent Contact is required when Agent-assigned is selected!");
        return;
      }
      if (!orderState?.tracking_url || !orderState.tracking_url.trim()) {
        toast.error("Tracking URL is required when Agent-assigned is selected!");
        return;
      }
      if (!orderState.tracking_url.trim().startsWith("https://")) {
        toast.error("Tracking URL must start with https://");
        return;
      }
    } else if (orderState?.tracking_url && !orderState.tracking_url.trim().startsWith("https://")) {
      toast.error("Tracking URL must start with https://");
      return;
    }
    setIsUpdatingOrder(true);
    try {
      const payload = {
        fulfillment_state: orderState?.fulfillment_state || "Pending",
        invoice_url: "",
        order_id: String(order_id || ""),
        order_state: orderState?.order_state || _orderDetail?.order_state || "Created",
        ...(orderState?.tracking_url ? { tracking_url: orderState.tracking_url } : {}),
        agent_name: orderState?.agent_name || "",
        agent_contact: orderState?.agent_contact || "",
      };

      const { data } = await axios({
        url: `${apiEndpoint}/snp/orders/update_order`,
        method: "POST",
        headers: {
          "Authorization": `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: payload,
      });

      if (data.status === true || data.status === 200 || data.success === true) {
        toast.success(data.message || "Order updated successfully!");
        if (order_id) {
          getorderDetails(order_id);
        }
      } else {
        toast.error(data.message || "Failed to update order");
      }
    } catch (err: any) {
      console.error("Update order error:", err);
      toast.error(err?.response?.data?.message || "Something went wrong while updating order!");
    } finally {
      setIsUpdatingOrder(false);
    }
  };

  // ----------------------------------------Code functions for Download invoice start-----------------------------------------
  async function PDFGenerator() {
    try {
      // Step 1: Get the invoice URL (JSON response, not blob)
      const response = await axios({
        url: `${apiEndpoint}/snp/orders/get-order-invoice/${order_id}`,
        method: "GET",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
        },
      });

      const invoiceUrl = response?.data?.invoiceUrl;

      if (!invoiceUrl) {
        toast.error(response?.data?.message || "Failed to generate invoice");
        return;
      }

      // Step 2: Fetch the actual PDF bytes from GCS
      try {
        const pdfRes = await fetch(invoiceUrl);
        if (!pdfRes.ok) throw new Error("Failed to fetch PDF file");

        const pdfBlob = await pdfRes.blob();
        const blobUrl = window.URL.createObjectURL(pdfBlob);

        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", `Invoice-${order_id}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(blobUrl);

        toast.success("Invoice PDF downloaded successfully!");
      } catch (fetchErr) {
        // CORS or network issue fetching GCS directly — fall back to opening in a new tab
        console.warn("Direct fetch failed, opening in new tab instead:", fetchErr);
        window.open(invoiceUrl, "_blank", "noopener,noreferrer");
        toast.success("Invoice opened in a new tab. Use your browser's save option to download.");
      }
    } catch (err: any) {
      console.error("Invoice PDF Download error:", err);
      toast.error(err?.response?.data?.message || "Error downloading invoice PDF from server");
    }
  }
  async function sendStatusHandler() {

    try {
      setsendingOrderStatus(true)
      const { data } = await axios({
        url: `${baseNodeapiUrl}/shiprocket/unsolicated_status`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: {
          "order_id": order_id
        }

      })

      if (data?.message?.ack?.status === "ACK") {
        toast.success("Unsolicated Status Updated")
        setsendingOrderStatus(false)
      } else {
        setsendingOrderStatus(false)
        toast.error("Error in Update!!")
      }
    } catch (err) {
      setsendingOrderStatus(false)
      console.log("Something Went Wrong!!", err)
    }
    setsendingOrderStatus(false)
    console.log(data)
  }


  // ----------------------------------------Code functions for Download invoice end-----------------------------------------


  const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref,
  ) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const [invoiceHolder, setInvoiceHolder] = useState({ origin: "manual", path: "" })
  const PdfHandler = async (e: any) => {

    try {
      const files = e.target.files;

      const uploadPromises = Array.from(files).map(async (file: any) => {
        let myFile = file.name.split(".");
        let myFileType = myFile[myFile.length - 1];

        const s3 = new aws.S3({
          accessKeyId: awsKeyId,
          secretAccessKey: awsSecretKey,
          region: awsRegion
        });

        const params = {
          Bucket: "ondc-marketplace",
          Key: `images/${uuidv4()}.${myFileType}`,
          Body: file,
          ContentType: file.type
        };

        let result = await s3.upload(params).promise();
        return result.Location;
      });

      const locations = await Promise.all(uploadPromises);
      let invoiceUrl = locations[0]
      setInvoiceHolder({ path: invoiceUrl, origin: "manual" })

    } catch (exception) {
      toast.error("Error in Adding Product Image");
      console.log(exception);
    }
  };

  async function saveInvoice() {
    try {
      const { data } = await axios({
        url: `${apiEndpoint}/addInvoiceurl`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: {
          order_id,
          invoice: invoiceHolder.path
        }
      })

      if (data.status == 200) {
        toast.success("Invoice Saved!");
        setInvoiceHolder({
          path: invoiceHolder.path,
          origin: "database"
        })
      } else {
        toast.error("Something went wrong, please try later!")
      }
    } catch (err) {
      toast.error("Server error, please try later!")
    }
  }

  return (
    <>
      <ThemeMaker>
        {!isLoading ? <div className="card container my-3 my-md-4 p-3 p-md-4" style={{ borderRadius: "20px", border: "1px solid #e5e7eb", boxShadow: "0 10px 30px rgba(15, 23, 42, 0.04)", background: "#ffffff", maxWidth: "100%" }}>
          <div className="d-flex align-items-center justify-content-between p-3 mb-4 rounded-lg flex-wrap" style={{ backgroundColor: "#fff7ed", border: "1px solid #ffedd5", borderRadius: "12px", gap: "8px" }}>
            <h5 className="m-0 font-weight-bold" style={{ color: "#0f172a", fontSize: "17px", wordBreak: "break-word" }}>Order ID: <span style={{ color: "#f97316" }}>{order_id}</span></h5>
          </div>

          {orderDetail &&
            orderDetail.map((item: any, index: any) => {
              return (
                <React.Fragment key={index}>
                  <div className="p-3 mb-3" style={{ borderRadius: "16px", border: "1px solid #e5e7eb", background: "#f8fafc" }}>
                    <strong style={{ color: "#f97316", fontSize: "15px", display: "block", marginBottom: "12px" }}>Items Details</strong>
                    <div className="d-flex flex-column flex-sm-row align-items-center align-items-sm-start" style={{ gap: "16px" }}>
                      <div className="text-center" style={{ flexShrink: 0 }}>
                        <img src={item?.image?.split(",")[0]} alt="image" className="img-fluid rounded" style={{ width: "120px", height: "120px", maxHeight: "140px", objectFit: "contain", borderRadius: "10px", background: "#ffffff", padding: "4px", border: "1px solid #e2e8f0" }} />
                      </div>
                      <div className="flex-grow-1 w-100" style={{ fontWeight: "500", fontSize: "14px", color: "#0f172a" }}>
                        <p className='mb-1 genericlabel' style={{ color: "#0f172a", fontSize: "15px" }}>Product: <span className="font-weight-bold" style={{ color: "#f97316" }}>{item?.product_name}</span> </p>

                        {item?.category_name ? (
                          <p className='mb-1 genericlabel' style={{ color: "#475569" }}>Category: <span> {item?.category_name}</span></p>
                        ) : (
                          ``
                        )}
                        {item?.weight ? <p className='mb-1 genericlabel' style={{ color: "#475569" }}>Size: <span>{item?.weight}</span> </p> : ``}
                        {item?.quantity ? (
                          <p className='mb-1 genericlabel' style={{ color: "#475569" }}>Qty: <span className="font-weight-bold" style={{ color: "#0f172a" }}> {item?.quantity}</span></p>
                        ) : (
                          ``
                        )}
                        {item?.cancel_qty ? (
                          <p className='mb-1 genericlabel text-danger'>Cancel Qty: {item?.cancel_qty}</p>
                        ) : (
                          ``
                        )}
                        {item?.price ? (
                          <p className='mb-1 genericlabel' style={{ color: "#0f172a", fontWeight: "600" }}>Price: ₹{item?.price}</p>
                        ) : (``)
                        }
                        {item?.fulfillment_state ? (
                          <p className='mb-1 genericlabel' style={{ fontWeight: "600" }}>
                            Fulfillment Status: <span style={{
                              color: item.fulfillment_state === "Order-delivered" ? "#16a34a" :
                                     item.fulfillment_state === "Out-for-delivery" ? "#2563eb" :
                                     item.fulfillment_state === "Cancelled" ? "#dc2626" : "#f59e0b",
                              fontWeight: 700
                            }}>{item.fulfillment_state}</span>
                          </p>
                        ) : null}
                        {alldetails?.reason_codes ? (
                          <p className='mb-1 genericlabel text-danger'>Cancellation Reason:  {cancelReasonStatement?.filter(item => item?.code == alldetails?.reason_codes)?.map(item => <span>{item?.text}</span>)}</p>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              );
            })}

          {orderState?.order_state !== "Cancelled" ? <div className="row d-flex ">
            <div className="col-md-6 col-sm-12 mb-3">
              <label
                htmlFor="exampleFormControlInput1"
                className="col-12 form-label genericlabel"
              >
                Order Status
              </label>
              <br />
              <select
                className="form-control col-md-8"
                style={{ borderRadius: "10px", borderColor: "#e5e7eb", height: "44px", fontSize: "14px" }}
                aria-label="size 3 select example"
                value={orderState?.order_state}
                name="order_state"
                onChange={(e) =>
                  setOrderState({
                    ...orderState,
                    [e.target.name]: e.target.value,
                  })
                }
              >
                {orderStatus.map((item) => {
                  return (
                    <option value={item} key={item}>
                      {item}
                    </option>
                  )
                })}
              </select>
            </div>

            <div className="col-md-6 col-sm-12 mb-3">
              <label
                htmlFor="exampleFormControlInput1"
                className="col-12 form-label genericlabel"
              >
                Fulfillment
              </label>
              <br />
              <select
                className="form-control col-md-8"
                style={{ borderRadius: "10px", borderColor: "#e5e7eb", height: "44px", fontSize: "14px" }}
                aria-label="size 3 select example"
                value={orderState?.fulfillment_state}
                name="fulfillment_state"
                onChange={(e) => {
                  setOrderState({
                    ...orderState,
                    [e.target.name]: e.target.value,
                  })
                }
                }
              >
                <option value="">Select Fulfillment Status</option>
                {(orderState?.order_state == "Created" || orderState?.order_state == "Accepted") && <> <option value="Pending">Pending</option> </>}

                {(orderState?.order_state == "In-progress") && <>
                  <option value="Packed">Packed</option>
                  <option value="Agent-assigned">Agent-assigned</option>

                  <option value="Order-picked-up">Order-picked-up</option>
                  <option value="Out-for-delivery">Out-for-delivery</option>

                </>}


                {(orderState?.order_state == "Completed") && <>
                  <option value="Order-delivered">Order-delivered</option>
                </>}
              </select>
            </div>
            {(orderState?.fulfillment_state === "Agent-assigned" ||
              Boolean(orderState?.agent_name) ||
              Boolean(orderState?.agent_contact) ||
              Boolean(orderState?.tracking_url)) && (
                <>
                  <div className="col-md-6 col-sm-12 mb-3">
                    <label
                      htmlFor="exampleFormControlInputAgentName"
                      className="col-12 form-label genericlabel"
                    >
                      Agent Name {orderState?.fulfillment_state === "Agent-assigned" && <span className="text-danger">*</span>}
                    </label>
                    <input
                      className="form-control"
                      style={{ borderRadius: "10px", borderColor: "#e5e7eb", height: "44px", fontSize: "14px" }}
                      type="text"
                      readOnly={agentFieldsReadOnly}
                      placeholder="Enter Agent Name..."
                      value={orderState?.agent_name}
                      name="agent_name"
                      required={orderState?.fulfillment_state === "Agent-assigned"}
                      onChange={(e) =>
                        setOrderState({
                          ...orderState,
                          [e.target.name]: e.target.value,
                        })
                      }
                    />
                  </div>

                  <div className="col-md-6 col-sm-12 mb-3">
                    <label
                      htmlFor="exampleFormControlInputAgentContact"
                      className="col-12 form-label genericlabel"
                    >
                      Agent Contact {orderState?.fulfillment_state === "Agent-assigned" && <span className="text-danger">*</span>}
                    </label>
                    <input
                      className="form-control"
                      style={{ borderRadius: "10px", borderColor: "#e5e7eb", height: "44px", fontSize: "14px" }}
                      type="text"
                      inputMode="numeric"
                      maxLength={10}
                      readOnly={agentFieldsReadOnly}
                      placeholder="Enter Agent Contact..."
                      value={orderState?.agent_contact}
                      name="agent_contact"
                      required={orderState?.fulfillment_state === "Agent-assigned"}
                      onChange={(e) => {
                        const val = e.target.value;
                        // Only digits allowed
                        if (!/^\d*$/.test(val)) return;
                        // First digit must be 6, 7, 8, or 9
                        if (val.length > 0 && !/^[6-9]/.test(val)) return;
                        // Max 10 digits
                        if (val.length > 10) return;
                        setOrderState({ ...orderState, agent_contact: val });
                      }}
                    />
                  </div>

                  <div className="col-12 mb-3">
                    <label
                      htmlFor="exampleFormControlInput1"
                      className="col-12 form-label genericlabel"
                    >
                      Tracking URL {orderState?.fulfillment_state === "Agent-assigned" && <span className="text-danger">*</span>}
                    </label>
                    <input
                      className="form-control"
                      style={{
                        borderRadius: "10px",
                        borderColor: Boolean(orderState?.tracking_url && !orderState.tracking_url.startsWith("https://")) ? "#dc2626" : "#e5e7eb",
                        height: "44px",
                        fontSize: "14px",
                      }}
                      type="text"
                      readOnly={agentFieldsReadOnly}
                      placeholder="Enter Tracking URL (e.g. https://...)"
                      value={orderState?.tracking_url}
                      name="tracking_url"
                      required={orderState?.fulfillment_state === "Agent-assigned"}
                      onChange={(e) =>
                        setOrderState({
                          ...orderState,
                          [e.target.name]: e.target.value,
                        })
                      }
                    />
                    {Boolean(orderState?.tracking_url && !orderState.tracking_url.startsWith("https://")) && (
                      <span className="text-danger mt-1 d-block" style={{ fontSize: "12px", fontWeight: 500 }}>
                        Tracking URL must start with https://
                      </span>
                    )}
                  </div>
                </>
              )}
            {showPop ? (
              <>
                <div
                  onClick={() => setShowPop(false)}
                  className={`cancelpopupoverlay`}
                ></div>
                <div className={`popup `}>
                  <p className="text-right p-2"> <CloseIcon role="button" onClick={() => setShowPop(false)} className="text-dark" />
                  </p>
                  <p className="text-center p-2" style={{ fontSize: "20px", fontWeight: "800", color: "black" }}>Partial Cancellation</p>

                  {orderDetail &&
                    orderDetail.map((item: any, index: any) => {
                      // console.log(item)
                      return (

                        <>
                          <div className="row p-4 mb-2" key={index}>
                            <div className="d-flex PMOrdeList" style={{ gap: "2px" }}>


                              <div style={{ width: "200px", height: "200px" }}>
                                <img src={item?.image} alt="" style={{ width: "100%", height: "100%" }} />
                              </div>

                              <div>
                                <div className="col-12 mb-2">
                                  <span className="allkeys">Product Name:</span>  {item.product_name}
                                </div>
                                <div className="col-md-12 ">
                                  <span className="allkeys">Order Quantity:</span>   {item.quantity}
                                </div>

                                {(item.quantity == item?.cancel_qty) ? <div className="mt-2"> <span className="badge badge-danger">Product Cancelled</span> </div> : <>
                                  <div className="col-md-12">
                                    <label className="col-form-label allkeys" >
                                      Cancel Quantity:
                                    </label>
                                    <input
                                      type="number"
                                      style={{
                                        border: "none",
                                        borderBottom: "1px solid #ccc",
                                      }}
                                      name="qty"
                                      min={1}
                                      max={item.quantity}
                                      value={item.qty}
                                      onChange={(e) => {
                                        // console.log(e.target.value)
                                        // cancleQty(item, e.target.value);
                                        if (item.cancel_qty === "") {
                                          if ((parseInt(e.target.value) < 1)) {
                                            setshowGreaterValueAlert(true);
                                            setTimeout(() => setshowGreaterValueAlert(false), 3000)
                                            // setcancelQuantityl("");
                                            e.target.value = ""
                                          } else {
                                            setcancelQuantityl(e.target.value)
                                          }

                                        } else {
                                          if ((parseInt(e.target.value) > (parseInt(item.quantity)) - parseInt(item.cancel_qty)) || (parseInt(e.target.value) < 1)) {
                                            // alert("Value is greater");
                                            setshowGreaterValueAlert(true);
                                            setTimeout(() => setshowGreaterValueAlert(false), 3000)
                                            setcancelQuantityl("");
                                            e.target.value = ""
                                          } else {
                                            setcancelQuantityl(e.target.value)
                                          }
                                        }


                                      }}
                                    // onChange={PartialCancelChangeHandler}
                                    />
                                  </div>
                                  <div className="col-md-12">
                                    {item?.cancel_qty && (
                                      <span className="allkeys" style={{ color: "red" }}>Cancelled Qty : {item?.cancel_qty}</span>
                                    )}
                                  </div>
                                  <div className="col-md-12" >
                                    <div>
                                      <label className="col-form-label allkeys">
                                        Cancel Reason:
                                      </label>
                                      <select className="col-md-6 text-left" name="reason" value={item.reason}

                                        onChange={(e) => {
                                          setreasonCode(e.target.value)
                                        }}
                                      >
                                        <option value="001">
                                          Select Cancle Reason
                                        </option>
                                        {
                                          cancelReasonStatement.filter(item => item?.show == true).map((item, index) => (
                                            <option value={item.code} key={index}>{item.text}</option>
                                          ))
                                        }
                                      </select>

                                    </div>
                                  </div>
                                  <div className="mt-2">
                                    <div className="col-6 justify-content-end position-relative p-2">
                                      <button
                                        className="btn btn-primary align-end"
                                        type="submit"
                                        onClick={(e) => cancelPartial(e, item)}
                                      >
                                        {
                                          cancellingProduct == item.id ? "Cancelling..." : "Cancel"
                                        }

                                      </button>
                                    </div>
                                  </div>
                                </>}

                              </div>
                            </div>
                          </div >
                          <hr className="hr" />
                        </>

                      );
                    })}

                  <div className="col-12 d-flex justify-content-end position-relative p-2">
                    <button
                      className="btn btn-primary align-end"
                      onClick={(e) => setShowPop(false)}
                    >
                      Done
                    </button>
                  </div>
                </div>
              </>
            ) : null}

            {order?.update ? <div className="row m-2 w-100 d-flex justify-content-between">
              <div className=" col-md-6 col-sm-12 mt-2">
                <button
                  className="btn btn-primary"
                  onClick={(e) => updateThisOrder(e)}
                >
                  Update
                </button>

                <button className="btn btn-secondary ml-2" onClick={sendStatusHandler} disabled={sendingOrderStatus} >
                  {sendingOrderStatus ? "Sending Staus..." : "Send Order Status"}
                </button>
                {/* <button
                  className="btn btn-secondary ml-3"
                  onClick={(e) => updateLSP(e)}
                >
                  Update LSP
                </button> */}
              </div>
              <div className="col-md-6 col-sm-12 mt-2 d-flex col-md-justify-content-end" style={{ gap: "10px" }}>

                {/* <button className="btn btn-primary" onClick={updateThisOrder}>
                  Update
                </button> */}


                <button
                  onClick={cancelbtn}
                  className="btn btn-outline-danger"
                >
                  Order Cancel
                </button>

                {cancelpopup ? (
                  <>
                    <div onClick={() => setcancelpopup(false)}
                      className={`cancelpopupoverlay`}></div>
                    <div className={`cancelorderpopup p-3 `}>
                      <div className="row">
                        <div className="col-12 ">
                          <select className="btn btn-outline-dark w-100 text-left"
                            value={cancelreson} onChange={(e) =>
                              changeReturnStatus(e.target.value)
                            }>
                            <option value="">
                              Select Cancel Reason
                            </option>
                            {/* <option value="001">
                                Price of one or more items have changed due to which buyer was asked to make additional payment
                              </option> */}
                            <option value="002">
                              One or more items in the Order not available
                            </option>
                            {/* <option value="003">
                                Product available at lower than order price
                              </option> */}
                            {/* <option value="004">
                                Order in pending shipment / delivery state for too long
                              </option> */}
                            <option value="005">
                              Merchant rejected the order
                            </option>
                            {/* <option value="006">
                                Order not shipped as per buyer app SLA
                              </option> */}
                            {/* <option value="008">
                                Order not ready for pickup
                              </option> */}
                            {/* <option value="009">
                                Wrong product delivered
                              </option> */}
                            {/* <option value="010">
                                Buyer wants to modify details
                              </option> */}
                            <option value="011">
                              Buyer not found or cannot be contacted
                            </option>
                            <option value="012">
                              Buyer does not want product any more
                            </option>
                            <option value="013">
                              Buyer refused to accept delivery
                            </option>
                            <option value="014">Address not found</option>
                            <option value="015">
                              Buyer not available at location
                            </option>
                            {/* <option value="016">
                                Accident / rain / strike / vehicle issues
                              </option>
                              <option value="017">
                                Order delivery delayed or not possible
                              </option> */}
                            <option value="018">
                              Delivery pin code not serviceable
                            </option>
                            <option value="019">
                              Pickup pin code not serviceable
                            </option>
                            <option value="020">
                              Order lost in transit
                            </option>
                          </select>
                          <p className="text-center mt-3 d-none">{`You selected : ${cancelreson}`}</p>
                        </div>
                        <div className="col-12 m-2 p-2 d-flex justify-content-between">
                          <button
                            className="btn btn-outline-dark col-5 col-md-5"
                            onClick={() => setcancelpopup(false)}
                          >
                            Close
                          </button>
                          <button
                            className="btn btn-outline-danger col-5 col-md-5"
                            onClick={() => ordercancel()}
                          >
                            Cancel Order
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                ) : null}


                {/* <button
                  className="btn btn-primary"
                  onClick={(e) => {
                    toggle(e);
                  }}
                >
                  Partial Cancelation
                </button> */}


              </div>
            </div> : null}
          </div> : <> <span className="badge badge-danger" style={{ display: "inline-block", marginBottom: "5px", marginLeft: "10px" }}>Order Cancelled</span>
            <button className="btn btn-secondary ml-2 col-md-3 w-75 w-md-25" onClick={sendStatusHandler} disabled={sendingOrderStatus} >
              {sendingOrderStatus ? "Sending Staus..." : "Send Order Status"}
            </button> </>}


          {/* ----------------------------------------HTML for Logistics Part Start ----------------------------------------------- */}
          <div className="m-2 p-2">
            <p className="d-flex justify-content-start align-items-center" style={{ gap: "10px" }}>
              <strong className="text-info">Logistics</strong>
              <input type="radio" checked name="logistics" style={{ width: "20px", height: "20px" }} />
              <label htmlFor="" className="m-0"> Off Network </label>
              <button
                type="button"
                className="btn btn-warning btn-sm font-weight-bold ml-2 text-white"
                style={{ backgroundColor: "#f97316", borderColor: "#f97316", borderRadius: "6px", padding: "4px 14px" }}
                onClick={handleUpdateOrder}
                disabled={isUpdatingOrder}
              >
                {isUpdatingOrder ? "Updating..." : "Update"}
              </button>
            </p>

            {/* <div className="d-flex align-items-center" style={{ gap: "2px" }}>
              <input type="radio" name="logistics" onChange={() => setWeightSection(false)} style={{ width: "12%", height: "20px" }} /> <label htmlFor=""> Off Network </label>
            </div> */}
            {/* <div className="d-flex align-items-center" style={{ gap: "2px" }}>
              <input type="radio" name="logistics" onChange={() => setWeightSection(true)} style={{ width: "12%", height: "20px" }} /> <label htmlFor="" className="m-0"> On Network </label>
              {selectProvider ? <Pbutton onClick={() => setprovidersModalOpen(true)} style={{ color: "white" }}>Get Providers</Pbutton> : (selectProvider == false) ? <BeatLoader ></BeatLoader> : null}
            </div> */}




            {WeightSection ? <div className="mt-3  d-flex dimensionMain" style={{ flexDirection: "column", gap: "10px" }}>
              <strong className="text-info">Weight & Dimensions</strong>
              <div>

                <div className="d-flex justify-content-center align-items-center" style={{ gap: "6px", width: "88%" }}>
                  Total Weight of Products:
                  <input type="number" className="" style={{ width: "60%" }} name="weight" onChange={(e: any) => { WandChangeHandler(e) }} />
                  <select id="" className="m-0" value={wAndD.weightUnit} name="weightUnit" onChange={(e: any) => { WandChangeHandler(e) }}>
                    <option value="">Select Unit</option>
                    <option value="Gram">Gram</option>
                    <option value="Kilogram">Kilogram</option>
                  </select>
                </div>


              </div>
              <div>
                <div className="d-flex justify-content-between mb-3" style={{ gap: "3px", width: "88%" }}>
                  Dimensions:
                  <select name="dimensionUnit" value={wAndD.dimensionUnit} onChange={(e: any) => { WandChangeHandler(e) }}>
                    <option value="">Select Unit</option>
                    <option value="meter">Meter</option>
                    <option value="centimeter">Centimeter</option>
                    <option value="inch">Inch</option>
                  </select>
                </div>


                <div className="d-flex flex-column" style={{ gap: "3px", width: "88%" }}>
                  <div className="d-flex justify-content-between" style={{ gap: "10px" }}>
                    <label htmlFor="">Length</label> <input type="number" name="length" value={wAndD?.length} onChange={(e: any) => { WandChangeHandler(e) }} />
                  </div>
                  <div className="d-flex  justify-content-between" style={{ gap: "10px" }}>
                    <label htmlFor="">Width</label> <input type="number" name="width" value={wAndD?.width} onChange={(e: any) => { WandChangeHandler(e) }} />
                  </div>
                  <div className="d-flex  justify-content-between" style={{ gap: "10px" }}>
                    <label htmlFor="">Height</label> <input type="number" name="height" value={wAndD?.height} onChange={(e: any) => { WandChangeHandler(e) }} />
                  </div>
                  <div className="d-flex justify-content-center">


                    <Pbutton onClick={getProvidersPayload} disabled={wAndD?.height !== "" ? false : true} style={{ color: "white", cursor: "pointer", marginTop: "10px" }}>Search Providers</Pbutton>

                  </div> </div>


              </div>
            </div> : null}

          </div>

          {/* ----------------------------------------HTML for Logistics Part end ----------------------------------------------- */}

          <button className="btn btn-success col-md-3 d-none" onClick={getShipmentStatus}>{shipmentStatusLoading ? <CircularProgress style={{ color: "white" }} size={20} /> : "Get Shipment Status"} </button>

          <TableContainer component={Paper} className="mt-4" style={{ borderRadius: "16px", overflowX: "auto", border: "1px solid #e5e7eb", boxShadow: "0 4px 20px rgba(15, 23, 42, 0.04)" }}>
            <div className="p-3 font-weight-bold text-white" style={{ backgroundColor: "rgb(249 115 22)", fontSize: "15px", letterSpacing: "0.5px" }}>Order Details</div>
            <Table sx={{ minWidth: "100%", width: "100%" }} aria-label="order details table">
              <TableBody>
                <TableRow>
                  <TableCell align="left" style={tableLabelStyle}>Order Number</TableCell>
                  <TableCell align="left" style={tableValueStyle}>{_orderDetail?.order_id || "N/A"}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left" style={tableLabelStyle}>Bill Number</TableCell>
                  <TableCell align="left" style={tableValueStyle}>GST {(_orderDetail?.order_id && _orderDetail?.order_id.length >= 17) ? _orderDetail?.order_id.slice(11, 17) : (_orderDetail?.order_id || "N/A")}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left" style={tableLabelStyle}>Bill Date</TableCell>
                  <TableCell align="left" style={tableValueStyle}>{_orderDetail?.billing_address?.created_at ? moment.utc(_orderDetail?.billing_address?.created_at).format("DD-MM-YYYY  HH:mm:ss") : (_orderDetail?.created_at ? moment.utc(_orderDetail?.created_at).format("DD-MM-YYYY  HH:mm:ss") : "N/A")}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left" style={tableLabelStyle}>Customer Name</TableCell>
                  <TableCell align="left" style={tableValueStyle}>{_orderDetail?.name || _orderDetail?.billing_address?.name || "N/A"}</TableCell>
                </TableRow>

                {logisticCharges?.breakup?.length === 3 ? (
                  <>
                    <TableRow>
                      <TableCell align="left" style={tableLabelStyle}>Delivery Charges</TableCell>
                      <TableCell align="left" style={tableValueStyle}>₹{(logisticCharges?.breakup && logisticCharges.breakup.length > 0) ? (logisticCharges?.breakup[logisticCharges?.breakup.length - 2]?.price?.value || 0) : 0}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell align="left" style={tableLabelStyle}>Packing Charges</TableCell>
                      <TableCell align="left" style={tableValueStyle}>₹{(logisticCharges?.breakup && logisticCharges.breakup.length > 0) ? (logisticCharges?.breakup[logisticCharges?.breakup.length - 1]?.price?.value || 0) : 0}</TableCell>
                    </TableRow>
                  </>
                ) : null}

                {logisticCharges?.breakup?.length === 2 ? (
                  <TableRow>
                    <TableCell align="left" style={tableLabelStyle}>Delivery Charges</TableCell>
                    <TableCell align="left" style={tableValueStyle}>₹{(logisticCharges?.breakup && logisticCharges.breakup.length > 0) ? (logisticCharges?.breakup[logisticCharges?.breakup.length - 1]?.price?.value || 0) : 0}</TableCell>
                  </TableRow>
                ) : null}

                <TableRow>
                  <TableCell align="left" style={tableLabelStyle}>Total Amount</TableCell>
                  <TableCell align="left" style={tableValueStyle}>₹{_orderDetail?.total_price || 0}</TableCell>
                </TableRow>
                {_orderDetail?.return_amount && _orderDetail?.return_amount !== 0 ? (
                  <TableRow>
                    <TableCell align="left" style={tableLabelStyle}>Cancel Return Amount</TableCell>
                    <TableCell align="left" style={{ ...tableValueStyle, color: "#dc2626" }}>-₹{_orderDetail?.return_amount}</TableCell>
                  </TableRow>
                ) : null}
                <TableRow>
                  <TableCell align="left" style={{ ...tableLabelStyle, color: "#f97316", fontWeight: 700 }}>Grand Total</TableCell>
                  <TableCell align="left" style={{ ...tableValueStyle, color: "#f97316", fontWeight: 700, fontSize: "15px" }}>₹{_orderDetail?.return_amount ? `${_orderDetail?.return_amt}` : `${_orderDetail?.total_price}`}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          {/* <div className="m-2 p-2">
            <strong className="text-info">Order Details</strong>
            <p className="d-flex justify-content-between">
              <span className="genericlabel">Order Number</span>
              <span style={{ textAlign: "end" }}>{_orderDetail?.order_id}</span>
            </p>
            <p className="d-flex justify-content-between">
              <span className="genericlabel"> Bill Number </span>
              <span style={{ textAlign: "end" }}>
                GST{_orderDetail?.order_id.slice(11, 17)}
              </span>
            </p>
            <p className="d-flex justify-content-between">
              <span className="genericlabel">Bill Date</span>
              <span style={{ textAlign: "end" }}>
                {_orderDetail?.billing_address?.created_at}
              </span>
            </p>
            <p className="d-flex justify-content-between">
              <span className="genericlabel">Customer Name</span>
              <span style={{ textAlign: "end" }}>{_orderDetail?.name}</span>
            </p>
            <p className="d-flex justify-content-between">
              <span className="genericlabel">Delivery Charges</span>
              <span style={{ textAlign: "end" }}>{(logisticCharges?.breakup && logisticCharges.breakup.length > 0) && logisticCharges?.breakup[logisticCharges?.breakup.length - 2]?.price?.value}</span>
            </p>
            <p className="d-flex justify-content-between">
              <span className="genericlabel"> Packing Charges</span>
              <span style={{ textAlign: "end" }}>{(logisticCharges?.breakup && logisticCharges.breakup.length > 0) && logisticCharges?.breakup[logisticCharges?.breakup.length - 1]?.price?.value}</span>
            </p>
            <p className="d-flex justify-content-between">
              <span className="genericlabel">Total Amount</span>
              <span style={{ textAlign: "end" }}>
                {_orderDetail?.total_price}
              </span>
            </p>
            {_orderDetail?.return_amount === 0 ? (
              " "
            ) : (
              <p className="d-flex justify-content-between">
                Cancel Return Amount{" "}
                <span style={{ textAlign: "end" }}>
                  -{_orderDetail?.return_amount}
                </span>
              </p>
            )}

            <hr />
            <p className="d-flex justify-content-between text-info">
              <strong>Grand Total</strong>{" "}
              <span style={{ textAlign: "end" }}>
                {_orderDetail?.return_amount
                  ? `${_orderDetail?.return_amt}`
                  : `${_orderDetail?.total_price}`}
              </span>
            </p>
          </div> */}

          <TableContainer component={Paper} className="mt-4" style={{ borderRadius: "16px", overflowX: "auto", border: "1px solid #e5e7eb", boxShadow: "0 4px 20px rgba(15, 23, 42, 0.04)" }}>
            <div className="p-3 font-weight-bold text-white" style={{ backgroundColor: "rgb(249 115 22)", fontSize: "15px", letterSpacing: "0.5px" }}>Payment Method</div>
            <Table sx={{ minWidth: "100%", width: "100%" }} aria-label="payment method table">
              <TableBody>
                <TableRow>
                  <TableCell align="left" style={tableLabelStyle}>Order Number</TableCell>
                  <TableCell align="left" style={tableValueStyle}>{(_orderDetail?.order_id && _orderDetail?.order_id.length >= 17) ? _orderDetail?.order_id.slice(11, 17) : (_orderDetail?.order_id || "N/A")}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left" style={tableLabelStyle}>Bill Date</TableCell>
                  <TableCell align="left" style={tableValueStyle}>{_orderDetail?.billing_address?.created_at ? moment.utc(_orderDetail?.billing_address?.created_at).format("DD-MM-YYYY  HH:mm:ss") : (_orderDetail?.created_at ? moment.utc(_orderDetail?.created_at).format("DD-MM-YYYY  HH:mm:ss") : "N/A")}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left" style={tableLabelStyle}>Total Amount</TableCell>
                  <TableCell align="left" style={{ ...tableValueStyle, color: "#16a34a", fontSize: "14px" }}>₹{_orderDetail?.order_total || _orderDetail?.total_price || 0}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          <TableContainer component={Paper} className="mt-4 mb-4" style={{ borderRadius: "16px", overflowX: "auto", border: "1px solid #e5e7eb", boxShadow: "0 4px 20px rgba(15, 23, 42, 0.04)" }}>
            <div className="p-3 font-weight-bold text-white" style={{ backgroundColor: "rgb(249 115 22)", fontSize: "15px", letterSpacing: "0.5px" }}>Shipping Address</div>
            <Table sx={{ minWidth: "100%", width: "100%" }} aria-label="shipping address table">
              <TableBody>
                <TableRow>
                  <TableCell align="left" style={tableLabelStyle}>Name</TableCell>
                  <TableCell align="left" style={tableValueStyle}>{_orderDetail?.billing_address?.name || _orderDetail?.name || _orderDetail?.shipping_address?.[0]?.customer?.person?.name || "N/A"}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left" style={tableLabelStyle}>Email</TableCell>
                  <TableCell align="left" style={tableValueStyle}>{_orderDetail?.billing_address?.email || _orderDetail?.email || _orderDetail?.shipping_address?.[0]?.end?.contact?.email || "N/A"}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left" style={tableLabelStyle}>Mobile Number</TableCell>
                  <TableCell align="left" style={tableValueStyle}>{_orderDetail?.billing_address?.phone || _orderDetail?.contact_number || _orderDetail?.shipping_address?.[0]?.end?.contact?.phone || "N/A"}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left" style={tableLabelStyle}>Address</TableCell>
                  <TableCell align="left" style={tableValueStyle}>
                    {([
                      _orderDetail?.billing_address?.address?.door || _orderDetail?.shipping_address?.[0]?.end?.location?.address?.door,
                      _orderDetail?.billing_address?.address?.building || _orderDetail?.shipping_address?.[0]?.end?.location?.address?.building,
                      _orderDetail?.billing_address?.address?.street || _orderDetail?.shipping_address?.[0]?.end?.location?.address?.street,
                      _orderDetail?.billing_address?.address?.locality || _orderDetail?.shipping_address?.[0]?.end?.location?.address?.locality
                    ].filter(Boolean).join(", ")) || "N/A"}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left" style={tableLabelStyle}>City</TableCell>
                  <TableCell align="left" style={tableValueStyle}>{_orderDetail?.billing_address?.address?.city || _orderDetail?.shipping_address?.[0]?.end?.location?.address?.city || "N/A"}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left" style={tableLabelStyle}>State</TableCell>
                  <TableCell align="left" style={tableValueStyle}>{_orderDetail?.billing_address?.address?.state || _orderDetail?.shipping_address?.[0]?.end?.location?.address?.state || "N/A"}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left" style={tableLabelStyle}>Country</TableCell>
                  <TableCell align="left" style={tableValueStyle}>{_orderDetail?.billing_address?.address?.country || _orderDetail?.shipping_address?.[0]?.end?.location?.address?.country || "IND"}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left" style={tableLabelStyle}>Pin Code</TableCell>
                  <TableCell align="left" style={tableValueStyle}>{_orderDetail?.billing_address?.address?.area_code || _orderDetail?.shipping_address?.[0]?.end?.location?.address?.area_code || "N/A"}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          {_orderDetail?.on_network && <TableContainer component={Paper} className="mt-5 mb-5" style={{ borderRadius: "16px", overflowX: "auto", border: "1px solid #e5e7eb", boxShadow: "0 4px 20px rgba(15, 23, 42, 0.04)" }}>
            <div className="p-3 font-weight-bold text-white" style={{ backgroundColor: "#0284c7", fontSize: "15px", letterSpacing: "0.5px" }}>Logistics Details Address</div>
            <Table sx={{ minWidth: "100%", width: "100%" }} aria-label="logistics table">
              <TableBody>
                <TableRow>
                  <TableCell align="left" style={tableLabelStyle}>Logistics provider name:</TableCell>
                  <TableCell align="left" style={tableValueStyle}>{_orderDetail?.shipping_address[0]?.["@ondc/org/provider_name"] || "N/A"}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left" style={tableLabelStyle}>Pickup OTP</TableCell>
                  <TableCell align="left" style={tableValueStyle}>{_orderDetail?.shipping_address[0]?.["start"]?.["instructions"]?.["short_desc"] || "N/A"}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left" style={tableLabelStyle}>Pickup Instruction</TableCell>
                  <TableCell align="left" style={tableValueStyle}>{_orderDetail?.shipping_address[0]?.["start"]?.["instructions"]?.["long_desc"] || "N/A"}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left" style={tableLabelStyle}>Delivery OTP</TableCell>
                  <TableCell align="left" style={tableValueStyle}>{_orderDetail?.shipping_address[0]?.["end"]?.["instructions"]?.["short_desc"] || "N/A"}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left" style={tableLabelStyle}>Delivery Instruction</TableCell>
                  <TableCell align="left" style={tableValueStyle}>{_orderDetail?.shipping_address[0]?.["end"]?.["instructions"]?.["long_desc"] || "N/A"}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left" style={tableLabelStyle}>Expected Pickup Time</TableCell>
                  <TableCell align="left" style={tableValueStyle}>{_orderDetail?.shipping_address[0]?.["start"]?.["time"]?.range?.start ? moment.utc(_orderDetail?.shipping_address[0]?.["start"]?.["time"]?.range?.start).format("DD MMM YYYY, hh:mm A") : "N/A"}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left" style={tableLabelStyle}>Expected Delivery Time</TableCell>
                  <TableCell align="left" style={tableValueStyle}>{_orderDetail?.shipping_address[0]?.["end"]?.["time"]?.range?.start ? moment.utc(_orderDetail?.shipping_address[0]?.["end"]?.["time"]?.range?.start).format("DD MMM YYYY, hh:mm A") : "N/A"}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>}

          {/* <div className="m-2 p-2">
            <strong className="text-info">Shipping Address</strong>
            <p className="d-flex justify-content-between">
              <span className="genericlabel">Name</span>
              <span style={{ textAlign: "end" }}>
                {_orderDetail?.billing_address?.name}
              </span>
            </p>
            <p className="d-flex justify-content-between">
              <span className="genericlabel">Email</span>
              <span style={{ textAlign: "end" }}>
                {_orderDetail?.billing_address?.email}
              </span>
            </p>
            <p className="d-flex justify-content-between">
              <span className="genericlabel">Mobile Number</span>
              <span style={{ textAlign: "end" }}>
                {_orderDetail?.billing_address?.phone}
              </span>
            </p>
            <p className="d-flex justify-content-between">
              <span className="genericlabel">Address</span>
              <span style={{ textAlign: "end" }} className="addressWidth">
                {_orderDetail?.billing_address?.address?.building}, {_orderDetail?.billing_address?.address?.locality}
              </span>
            </p>
            <p className="d-flex justify-content-between">
              <span className="genericlabel">City</span>
              <span style={{ textAlign: "end" }}>
                {_orderDetail?.billing_address?.address?.city}
              </span>
            </p>
            <p className="d-flex justify-content-between">
              <span className="genericlabel">State</span>
              <span style={{ textAlign: "end" }}>
                {_orderDetail?.billing_address?.address?.state}
              </span>
            </p>
            <p className="d-flex justify-content-between">
              <span className="genericlabel">Country</span>
              <span style={{ textAlign: "end" }}>
                {_orderDetail?.billing_address?.address?.country}
              </span>
            </p>
            <p className="d-flex justify-content-between">
              <span className="genericlabel">Pincode</span>
              <span style={{ textAlign: "end" }}>
                {_orderDetail?.billing_address?.address?.area_code}
              </span>
            </p>
          </div> */}

          {/* <Link to={`/invoice/${order_id}`}> <Pbutton style={{ marginBottom: "10px" }}>Check Invoice</Pbutton> </Link> */}
          <div className="d-flex justify-content-center align-items-center" style={{ gap: "20px" }}>

            <div className="d-flex justify-content-center">
              <Pbutton onClick={PDFGenerator} className='my-2' style={{ margin: "0 auto", display: "block", color: "white" }}>System Generated Invoice</Pbutton>
            </div>

            {/* <p className="m-0">OR</p> */}

            {/* {invoiceHolder.origin === "database" && <p className="d-flex align-items-center m-0"> <a href={invoiceHolder?.path} target="_blank" style={{ textDecoration: "underline" }}>Store Invoice</a> </p>} */}

            {/* {invoiceHolder.origin === "manual" && <div className="d-flex align-items-center" style={{ gap: "10px" }}>
              <label htmlFor="" className="genericlabel m-0">Upload Invoice</label>
              <input type="file" className="form-control" accept="image/*" name="upload_pdf"
                onChange={(e) => PdfHandler(e)} style={{ width: "250px" }}
              />
              <button className="btn btn-sm btn-primary" onClick={saveInvoice}>Save</button>
            </div>} */}

          </div>
          <div style={{ display: "none" }}>
            <Invoice orderId={order_id} />
          </div>

        </div > :
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "90vh", width: "100%" }}><CircularProgress /></div>}

        <>
          <Modal
            open={shipmentModalOpen}
            onClose={handleShipementModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={Sstyle}>

              <div className="d-flex justify-content-end">
                <span style={{ cursor: "pointer" }} onClick={() => {
                  setshipmentModalOpen(false)
                }}><CloseIcon /></span>
              </div>
              <div style={{ padding: "20px" }}>

                <Box sx={{ width: '100%' }}>
                  <Stepper activeStep={0} alternativeLabel>
                    {steps.map((label) => (
                      <Step key={label}>
                        <StepLabel >{label}</StepLabel>
                      </Step>
                    ))}
                  </Stepper>
                </Box>
              </div>
            </Box>
          </Modal>
        </>

        <>
          <Modal
            open={providersModalOpen}
            onClose={() => setprovidersModalOpen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={PSstyle} className="providersModal">

              <ProviderContainer>
                <div className="d-flex flex-column align-items-center" >
                  <p style={{ position: "absolute", top: "5px", right: "10px", color: "black", cursor: "pointer", fontSize: "14px" }} onClick={() => {
                    setprovidersModalOpen(false)
                  }}><CloseIcon style={{ cursor: "pointer" }} /></p>
                  <h3 className="text-center mt-2" style={{ fontSize: "17px", color: "balck", fontWeight: "600" }}>Providers</h3>

                  <div className="w-100 d-flex flex-column align-items-center" style={{ gap: "13px", maxHeight: "320px", overflow: "scroll" }}>
                    {
                      providersData?.map((item: any, index: any) => {
                        if (index >= issChecked.length) {
                          setIssChecked(prevState => [
                            ...prevState,
                            { id: index, checked: false }
                          ]);
                        }

                        return <ListContainer key={index}>
                          <p style={{ color: "black" }}>Name: {item.bpp_descriptor_name}</p>
                          <p style={{ color: "black" }}>Category: {item.item.category_id}</p>
                          <p style={{ color: "black" }}>Item id: {item?.item?.id} </p>
                          <div style={{ color: "black" }} className="d-flex justify-content-between">Price:Rs{item.item.price.value}
                            <section>
                              <label htmlFor="" style={{
                                display: "inline-block",
                                marginLeft: "5px",
                                color: "black",
                              }}>Select</label>
                              <input type="radio" name="choose"
                                id=""
                                onChange={() => { selectLogisticProvider(item, index) }} style={{
                                  appearance: "none", marginRight: "5px",
                                  position: "relative",
                                  top: "2px",
                                  width: "13px",
                                  height: "13px",
                                  borderRadius: "50%",
                                  border: "1px solid blue",
                                  backgroundColor: issChecked[index]?.checked ? "blue" : "transparent",
                                  outline: "none",
                                  marginLeft: "3px"
                                }}
                              />
                            </section> </div>

                        </ListContainer>
                      })
                    }

                  </div>
                </div>
                <button onClick={submitSelectedProvider} className="btn btn-primary my-2 text-light col-md-2" >{isSelectingProviders ? <CircularProgress style={{ color: "white" }} size={20} /> : "Submit"}</button>

              </ProviderContainer>

            </Box>


          </Modal>

        </>
        <>
          <Modal
            open={isConfirmingProviders}

            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={PSstyle} className="providersModal">

              <ProviderContainer>
                <div className="d-flex flex-column align-items-center " style={{ height: "220px" }} >
                  <p style={{ position: "absolute", top: "5px", right: "10px", color: "black" }} onClick={() => {
                    setisConfirmingProviders(false)
                  }}><CloseIcon style={{ cursor: "pointer" }} /></p>
                  <h3 className="text-center mt-2" style={{ fontSize: "17px", color: "balck", fontWeight: "600" }}>Confirm Provider</h3>

                  <div className="w-100 d-flex flex-column mt-2" style={{ gap: "6px", maxHeight: "250px", overflow: "scroll" }}>

                    <p className="p-0 m-0"> <span style={textStyle1}> Provider Name:</span> <span className="ml-3"> {submitData?.descripter}</span></p>
                    <p className="p-0 m-0"> <span style={textStyle1}>Category: </span> <span className="ml-3">{submitData?.item?.category_id}</span> </p>
                    <p className="p-0 m-0"> <span style={textStyle1}>Price:</span>  <span className="ml-2">Rs. {submitData?.item?.price?.value}</span>  </p>

                  </div>
                  <div className="d-flex" style={{ gap: "13px" }}>
                    <button onClick={() => { onConfirmHandler(submitData) }} className="btn btn-primary col-md-8 mt-4">{isConfirmingProvider ? <CircularProgress style={{ color: "white" }} size={15} /> : "Confirm"}</button>

                    <button onClick={() => { updateLSP(submitData) }} className="btn btn-primary col-md-8  mt-4">{isUpdatingProvider ? <CircularProgress style={{ color: "white" }} size={15} /> : "Update"}</button>
                  </div>

                </div>
              </ProviderContainer>
            </Box>


          </Modal>

        </>
        <Snackbar open={showGreaterValueAlert} autoHideDuration={2000} >
          <Alert severity="error" sx={{ width: '100%' }}>
            Please fill correct quantity
          </Alert>
        </Snackbar>
        <Snackbar open={showEnterValueAlert} autoHideDuration={3000} >
          <Alert severity="error" sx={{ width: '100%' }}>
            Please enter cancel quantity and reason for cancel
          </Alert>
        </Snackbar>
        <Snackbar open={showCancelQuantityGreaterthenOrderQuantity} autoHideDuration={3000} >
          <Alert severity="error" sx={{ width: '100%' }}>
            Cancel Quantity Can't be grater then Order Quantity
          </Alert>
        </Snackbar>


      </ThemeMaker >
    </>
  );
};

export default orderDetail;
